export default __webpack_public_path__ + "static/media/clip-grey.c4df7d74.svg";